<template>
  <div class="download-app-jd-page">
    <!-- iframeUrl 有值：仅展示 iframe -->
    <div v-if="isIframeMode" class="iframe-mode">
      <iframe
        ref="iframe"
        :src="iframeUrl"
        class="iframe-mode-content"
        frameborder="0"
        allowfullscreen
        @load="onIframeLoad"
      ></iframe>
    </div>

    <!-- hasPushSuccess=1：进件成功，展示 result_sjh 样式与逻辑 -->
    <div v-else-if="isPushSuccessMode" class="container" v-cloak>
      <div class="top-con u-text-center">
        <template v-if="hasPushSuccess == 2">
          <div class="top-con-tit">
            <img src="../../assets/images/img_tel.png" />
          </div>
          <h4>请等待客户经理来电</h4>
          <p>
            第三方客户经理将在次日9:00~18:00通过电话为
            <br />您提供借款审批服务，请注意接听，配合借款审批
          </p>
        </template>
        <template v-else>
          <div class="top-con-tit">
            <h4>恭喜您！贷款申请已成功</h4>
          </div>
        </template>
      </div>

      <div class="mechanism-con">
        <div class="mechanism-info">
          <div class="pr">
            <div
              class="u-flex-1 u-text-center mechanism-info-div"
              v-if="applyId === '0' || !productName"
            >
              <div class="origan-desc">— 请注意接听该机构电话 —</div>
              <div class="u-flex u-row-between u-col-center">
                <p class="u-flex-1 origan-right" v-if="applyId === '0' || !productName">
                  正在匹配中...
                </p>
              </div>
            </div>

            <template v-else>
              <div class="mechanism-info-div-success">
                <img
                  class="success-phone"
                  src="../../assets/images/image_orange/result/top_phone.png"
                  alt=""
                />
                <div class="success-title">等待资方电话复审</div>
                <div class="success-tips">
                  首次借款需资方客户经理电话联系您确认相关信息请注意接听!
                </div>
                <div class="success-info">
                  <div class="success-info-name">
                    <span>{{ productName }}</span>
                  </div>
                  <div class="success-info-basic">
                    <div class="success-info-basic-label">最高可借金额：</div>
                    <div>¥ {{ creditAmount }}</div>
                  </div>
                  <div class="success-info-basic" v-if="institutionName">
                    <div class="success-info-basic-label">公司名称：</div>
                    <div>{{ institutionName }}</div>
                  </div>
                  <!-- 年化利率严格使用结果接口返回值，避免前端固定口径与最终审批信息不一致。 -->
                  <div class="success-info-basic" v-if="annualRate">
                    <div class="success-info-basic-label">年化利率(单利)：</div>
                    <div>{{ annualRate }}(已包含全部息费)</div>
                  </div>
                  <div class="success-tips">*为保证电话复审通过，请你注意接听来电</div>
                </div>
              </div>
            </template>

            <van-button
              class="download-app-btn"
              type="default"
              @click="onUserConfirmQuotaClick"
              block
              v-if="isRedirectProductsPage == 1"
            >
              <span>确认额度</span>
            </van-button>
            <van-button
              class="download-app-btn"
              type="default"
              @click="onUserConfirmQuotaClick"
              block
              v-if="isRedirectProductsPage == 0"
            >
              <span>去app确认额度</span>
            </van-button>
          </div>

          <div class="pagecard">
            <h4>贷款流程</h4>
            <ul class="u-flex u-text-center pagecard-process">
              <li class="loan-process-li u-flex-1">
                <img src="../../assets/images/image_orange/result/icon_safe.png" />
                <h6>风控系统审核</h6>
                <div class="u-flex u-row-center">
                  <img
                    class="icon-img"
                    src="../../assets/images/image_orange/result/icon_pass.png"
                  />
                  <span class="green">已通过</span>
                </div>
              </li>
              <li class="line pr">
                <img class="pa" src="../../assets/images/image_orange/result/icon_right.png" />
              </li>
              <li class="loan-process-li u-flex-1">
                <img src="../../assets/images/image_orange/result/icon_phone.png" />
                <h6>电话复审</h6>
                <div class="u-flex u-row-center">
                  <img
                    class="icon-img"
                    src="../../assets/images/image_orange/result/icon_dot_orange.png"
                  />
                  <span class="yellow">进行中</span>
                </div>
              </li>
              <li class="line pr">
                <img class="pa" src="../../assets/images/image_orange/result/icon_right.png" />
              </li>
              <li class="loan-process-li u-flex-1">
                <img src="../../assets/images/image_orange/result/icon_money.png" />
                <h6 style="color: #c2c3c4">申请提现</h6>
                <div class="u-flex u-row-center">
                  <img
                    class="icon-img"
                    src="../../assets/images/image_orange/result/icon_dot_gray.png"
                  />
                  <span class="default">等待电话复审</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="downloadBtnContainer" v-if="isH5DownloadAppShow == 1">
        <van-button type="default" block class="download-app-btn" @click="handleDownload">
          <span class="span">下载闪借花APP</span>领取额度
        </van-button>
      </div>
    </div>

    <!-- 默认：下载页样式与逻辑 -->
    <div v-else class="download-box">
      <!-- 顶部标题 -->
      <div class="header-title">
        <img class="logo" src="../../assets/images/entryThemeOne/logo-orange.png" />
      </div>
      <h1 class="main-title">
        <img src="../../assets/images/entryThemeOne/result-loan-user.png" alt="" />
      </h1>
      <!-- 主内容区域 -->
      <div class="main-content u-text-center">
        <div class="trapezoid">安全合规</div>
        <!-- 金额 -->
        <div class="auth-success">
          <p>最高可借额度(元)</p>
          <h2>200,000</h2>
        </div>

        <!-- 合规调整：移除夸大流程时效的宣传，仅保留一般提示。 -->
        <div class="credit-module bg-rotate">
          <div class="speed-channel">
            <div class="channel-info">
              <!-- 删除固定速度比例，仅保留速度提示和箭头标识。 -->
              <p class="speed-info">
                放款速度
                <span class="speed-icon">
                  <img src="../../assets/images/entryThemeOne/icon-up-arrow.png" alt="" />
                </span>
              </p>
            </div>
            <p class="speed-quotation">专享资格</p>
          </div>
        </div>

        <!-- 下载按钮 -->
        <van-button class="download-btn" type="default" @click="onUserDownloadClick">
          <img
            class="download-icon"
            src="../../assets/images/entryThemeOne/down-vector.png"
            alt=""
          />
          <span>下载APP 匹配更多资金</span>
        </van-button>
        <p class="download-tips">*页面额度仅供参考，实际下款金额以最终审批为准</p>
      </div>

      <!-- 温馨提示 -->
      <div class="tips-section">
        <p class="tips-text">
          温馨提示：未经您的明示许可，本平台不会对您的个人信息进行任何处理行为。请谨防第三方短信、电话诈骗，确保您的隐私与资金安全
        </p>
      </div>

      <!-- 3步完成借款 -->
      <div class="steps-section">
        <div class="steps-title">
          <img
            class="header-line left"
            src="../../assets/images/entryThemeOne/header-line.png"
            alt=""
          />
          <span class="steps-title-text">产品优势</span>
          <img class="header-line" src="../../assets/images/entryThemeOne/header-line.png" alt="" />
        </div>
        <div class="steps-container">
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_2.png" alt="" />
            </div>
            <div class="step-text">灵活额度</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_3.png" alt="" />
            </div>
            <!-- 合规调整：使用中性流程名称，不承诺审批速度。 -->
            <div class="step-text">资料审核</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_4.png" alt="" />
            </div>
            <div class="step-text">安全保障</div>
          </div>
        </div>
      </div>
    </div>

    <SharePop v-if="!isIframeMode" :show="showPop" @change="handlePopChange" />
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'

export default {
  name: 'DownloadApp',
  data() {
    const query = this.$route.query
    const redirectProductsPage = parseInt(query.isRedirectProductsPage, 10)
    const rawApplyId = query.applyId
    const applyId =
      rawApplyId && rawApplyId !== 'undefined' && rawApplyId !== 'null' ? rawApplyId : ''
    return {
      // 下载页
      channel: query.source,
      brand: query.brand,
      showPop: false,
      // 进件成功页（result_sjh）
      source: query.source || '',
      applyId,
      isRedirectProductsPage: Number.isNaN(redirectProductsPage) ? 0 : redirectProductsPage,
      productLogo: '',
      productName: '',
      callMobile: '',
      downAppUrl: undefined,
      apiReqType: query.apiReqType,
      isH5DownloadAppShow: parseInt(query.isH5DownloadAppShow),
      hasPushSuccess: null,
      creditAmount: 0,
      institutionName: '',
      annualRate: '', // 结果接口返回的年化利率，空值时不展示
      iframeUrl: query.iframeUrl ? decodeURIComponent(query.iframeUrl) : '',
      iframeLoadTimer: null,
      iframeLoadTracked: false,
    }
  },
  computed: {
    isIframeMode() {
      return !!this.iframeUrl
    },
    isPushSuccessMode() {
      const val = this.$route.query.hasPushSuccess
      return val == 1 || val === '1'
    },
  },
  created() {
    this.clearPageFavicon()
    if (this.isIframeMode) {
      window.__TRACK_SCENE_KEY__ = 'downloadAppJd'
      return
    }
    window.__TRACK_SCENE_KEY__ = this.isPushSuccessMode ? 'resultSjh' : 'resultLoanThemeTwo'
  },
  mounted() {
    API_Common.handleBatchTrackBase(100067)
    if (this.isIframeMode) {
      API_Common.handleBatchTrackBase(100066)
      this.initIframeMode()
      return
    }
    if (this.isPushSuccessMode) {
      this.initPushSuccessPage()
    } else {
      this.initDownloadPage()
    }
  },
  methods: {
    clearPageFavicon() {
      const iconLinks = Array.from(document.querySelectorAll("link[rel*='icon']"))
      this._savedFaviconLinks = iconLinks.map((link) => ({
        rel: link.rel,
        type: link.type,
        href: link.getAttribute('href') || link.href,
      }))
      iconLinks.forEach((link) => link.parentNode && link.parentNode.removeChild(link))

      const blankLink = document.createElement('link')
      blankLink.id = 'download-app-jd-blank-favicon'
      blankLink.rel = 'icon'
      blankLink.href =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      document.head.appendChild(blankLink)
    },
    restorePageFavicon() {
      const blankLink = document.getElementById('download-app-jd-blank-favicon')
      if (blankLink && blankLink.parentNode) {
        blankLink.parentNode.removeChild(blankLink)
      }
      if (!this._savedFaviconLinks || !this._savedFaviconLinks.length) return

      this._savedFaviconLinks.forEach(({ rel, type, href }) => {
        const link = document.createElement('link')
        link.rel = rel
        if (type) link.type = type
        link.href = href
        document.head.appendChild(link)
      })
      this._savedFaviconLinks = null
    },
    getTrackChannelCode() {
      const fromRoute = this.source || this.channel || this.$route.query.source || ''
      if (fromRoute) return fromRoute
      if (!this.iframeUrl) return ''
      try {
        const url = new URL(this.iframeUrl)
        return url.searchParams.get('source') || url.searchParams.get('channel') || ''
      } catch (e) {
        return ''
      }
    },
    iframeTrackContext(extra = {}) {
      return {
        channelCode: this.getTrackChannelCode(),
        ...extra,
      }
    },
    initIframeMode() {
      if (!this.iframeUrl || !/^https?:\/\/.+/i.test(this.iframeUrl)) {
        this.trackIframeLoadResult(false)
        return
      }

      this.iframeLoadTimer = setTimeout(() => {
        this.trackIframeLoadResult(false)
      }, 2000)
    },
    clearIframeLoadTimer() {
      if (this.iframeLoadTimer) {
        clearTimeout(this.iframeLoadTimer)
        this.iframeLoadTimer = null
      }
    },
    trackIframeLoadResult(success) {
      if (this.iframeLoadTracked) return
      this.iframeLoadTracked = true
      API_Common.handleBatchTrackBase(success ? 100071 : 100070, { remark: this.iframeUrl })
    },
    onIframeLoad() {
      this.clearIframeLoadTimer()

      setTimeout(() => {
        if (this.iframeLoadTracked) return

        try {
          const iframe = this.$refs.iframe
          if (!iframe) {
            this.trackIframeLoadResult(false)
            return
          }

          const doc = iframe.contentDocument || iframe.contentWindow?.document
          if (doc) {
            const content = doc.body?.innerHTML || ''
            if (content.trim().length < 10) {
              this.trackIframeLoadResult(false)
              return
            }
          }
        } catch (e) {
          // 跨域说明已加载外部页面，视为成功
        }

        this.trackIframeLoadResult(true)
      }, 500)
    },
    initDownloadPage() {
      API_Common.handleBatchTrackBase(100052)
      this.getJdDownloadUrl()
    },
    initPushSuccessPage() {
      API_Common.handleBatchTrackBase(100036)
      if (this.applyId && this.applyId !== '0') {
        this.getMechanismInfo()
      }
      this.getSjhDownloadUrl()
      if (this.source == 'ceshi003') {
        document.title = '湘江源小贷'
      }
    },
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    handleJdDownload() {
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else if (this.brand === 'xiaomi') {
        window.location.href = 'https://app.xiaomi.com/detail/1500555'
      } else {
        window.location.href = this.downAppUrl
      }
    },
    onUserDownloadClick() {
      API_Common.handleBatchTrackBase(100053)
      this.handleJdDownload()
    },
    handlePopChange(show) {
      this.showPop = show
    },
    getJdDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },
    getMechanismInfo() {
      let obj = {
        applyId: this.applyId,
        apiReqType: this.apiReqType,
      }
      API_Common.getMechanismInfo(obj).then((res) => {
        if (res.code === 200) {
          if (res.data.hasPushSuccess === 1) {
            this.productName = res.data.productName
            this.productLogo = res.data.productLogo
            this.callMobile = res.data.callMobile
            this.creditAmount = res.data.creditAmount
            this.institutionName = res.data.institutionName
            this.annualRate = res.data.annualRate || ''
          }
          this.hasPushSuccess = res.data.hasPushSuccess
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getSjhDownloadUrl() {
      API_Common.getDownloadUrl(this.source, true).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },
    autoDownloadApp() {
      if (this.isWeixin()) {
        this.$toast.clear()
        this.$toast('请在浏览器中打开此页面进行下载')
        return
      }
      const source = this.source || ''
      this.$toast.loading({
        message: '获取下载地址中...',
        forbidClick: true,
      })
      API_Common.getDownloadUrl(source, true)
        .then((res) => {
          this.$toast.clear()
          if (res.code === 200 && res.data && res.data.url) {
            window.location.href = res.data.url
          } else {
            this.$toast.fail(res.msg || '下载地址获取失败，请稍后重试')
          }
        })
        .catch((err) => {
          this.$toast.clear()
          console.error('获取下载地址失败:', err)
          this.$toast.fail('下载地址获取失败，请稍后重试')
        })
    },
    handleIGotIt() {
      this.runHalfDownloadOrElse(() => {
        const timestamp = new Date().getTime()
        if (this.isRedirectProductsPage == 1) {
          window.location.href = `/productListSjh.html?source=${this.source}&tsp=${timestamp}`
        } else {
          this.autoDownloadApp()
        }
      })
    },
    trackTl5ThemeOneBase(eventType) {
      API_Common.handleBatchTrackBase(eventType)
    },
    runHalfDownloadOrElse(fallback) {
      const processId = this.$route.query.processId
      if (!processId) {
        fallback()
        return
      }
      const channelCode = this.source || this.$route.query.source || ''
      API_Common.getHalfDownloadUrl(channelCode, processId)
        .then((res) => {
          if (res.code === 200 && res.data && res.data.url) {
            API_Common.handleBatchTrackBase(100058, { remark: res.data.url })
            window.location.href = res.data.url
            return
          }
          fallback()
        })
        .catch(() => fallback())
    },
    onUserConfirmQuotaClick() {
      if (this.isRedirectProductsPage === 1) {
        this.trackTl5ThemeOneBase('100037')
      } else {
        this.trackTl5ThemeOneBase('100038')
      }
      this.handleIGotIt()
    },
    handleDownload() {
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else if (this.brand === 'xiaomi') {
        window.location.href = 'https://app.xiaomi.com/detail/1500555'
      } else {
        this.runHalfDownloadOrElse(() => {
          setTimeout(() => {
            window.location.href = this.downAppUrl
          }, 50)
        })
      }
    },
  },
  beforeDestroy() {
    this.restorePageFavicon()
    window.__TRACK_SCENE_KEY__ = ''
    if (this.isIframeMode) {
      this.clearIframeLoadTimer()
      return
    }
  },
}
</script>

<style lang="scss" scoped>
.iframe-mode {
  width: 100%;
  height: 100vh;

  .iframe-mode-content {
    width: 100%;
    height: 100%;
    border: none;
  }
}

.download-box {
  min-height: 100vh;
  background-image: url('../../assets/images/entryThemeOne/result-loan-bg.png');
  background-size: 100% 6rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  font-size: 0.24rem;
  padding: 0.1rem 0.3rem;

  // 顶部标题
  .header-title {
    padding: 0.3rem 0;

    .logo {
      width: 4rem;
      height: auto;
      margin-bottom: 0.16rem;
    }

    .title-text {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333;
    }
  }

  // 主内容区域
  .main-title {
    font-size: 0.48rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.6rem;
    text-align: center;
    img {
      width: 100%;
      height: auto;
    }
    .amount {
      color: #ff5713;
    }
  }
  .main-content {
    padding: 0.01rem 0.3rem 0.5rem;
    background: linear-gradient(180deg, #ffebdf 0%, #fffefd 21.48%, #fffdfc 100%);
    border: 1px solid #fff;
    border-radius: 0.16rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.05);

    .credit-module {
      position: relative;
      border-radius: 0.24rem;
      margin-bottom: 0.2rem;
      background: #f9f9f9;
      padding: 0.28rem 0.2rem;
      &.bg-rotate {
        background: linear-gradient(135deg, #fff2eb 0%, #fff6f0 100%);
        border: 1px solid #ffe6d9;
      }

      .speed-channel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.15rem 0.2rem;

        .channel-info {
          flex: 1;

          .channel-title {
            font-size: 0.26rem;
            color: #601b00;
            margin-top: 0.08rem;
            margin-bottom: 0.18rem;
            text-align: left;
          }
          .speed-info {
            display: flex;
            align-items: center;
            font-size: 0.3rem;
            font-weight: 600;
            color: #601b00;
            text-align: left;
            .speed-icon {
              margin-left: 0.08rem;
            }
          }
        }

        .speed-quotation {
          position: absolute;
          top: 0rem;
          right: 0rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #fff;
          margin: 0;
          padding: 0.08rem 0.15rem;
          background-color: #ff6410;
          border-top-right-radius: 0.3rem;
          border-bottom-left-radius: 0.3rem;
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 50%);
        }
      }
    }

    // 圆角梯形
    .trapezoid {
      display: inline-block;
      position: relative;
      padding: 0.14rem 1rem;
      background: #ffba9160;
      color: #6c2e08;
      font-size: 0.28rem;
      font-weight: 500;
      margin-bottom: 0.4rem;
      border-radius: 0 0 0.6rem 0.6rem;

      // 使用clip-path创建圆角梯形效果
      clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);

      // 调整文字样式
      text-align: center;
      line-height: 1.4;
      // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    // 成功图标
    .success-icon {
      margin-bottom: 0.4rem;
      img {
        width: 1.4rem;
        height: auto;
      }
      .icon-circle {
        width: 1.2rem;
        height: 1.2rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }

    // 认证成功提示
    .auth-success {
      margin-bottom: 0.6rem;

      h2 {
        font-size: 0.8rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.16rem;
      }

      p {
        font-size: 0.28rem;
        color: #666;
        margin-bottom: 0.5rem;
      }
    }

    // 福利卡片
    .benefit-cards {
      display: flex;
      justify-content: center;
      margin-bottom: 0.6rem;
      img {
        width: 6rem;
        height: auto;
      }
    }

    // 下载按钮
    .download-btn {
      width: 100%;
      height: 1rem;
      background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
      border-radius: 0.5rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.24rem;
      .download-icon {
        width: 0.32rem;
        height: auto;
      }
      span {
        margin-left: 0.12rem;
      }
    }

    .download-tips {
      font-size: 0.24rem;
      color: #999;
    }
  }

  // 温馨提示
  .tips-section {
    padding: 0.2rem;
    margin-bottom: 0.6rem;
    background: #fffbf9;
    border-radius: 0.24rem;
    margin: 0.3rem 0;
    .tips-text {
      font-size: 0.22rem;
      color: #75280b;
      line-height: 1.5;
      text-align: left;
    }
  }

  // 流程步骤
  .process-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.4rem;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-icon {
        width: 0.6rem;
        height: 0.6rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        color: white;
        font-size: 0.28rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.12rem;
      }

      .step-text {
        font-size: 0.22rem;
        color: #666;
      }
    }

    .step-arrow {
      margin: 0 0.1rem;
      color: #999;
    }
  }

  /* 3步完成借款 */
  .steps-section {
    background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
    margin: 0.32rem 0;
    padding: 0.4rem;
    border-radius: 0.24rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .steps-title {
      font-size: 0.32rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.32rem;
      color: #333;
      .header-line {
        width: 1rem;
        height: 0.1rem;
        margin-bottom: 0.15rem;
        &.left {
          transform: rotate(180deg);
        }
      }
      .steps-title-text {
        margin: 0 0.2rem;
      }
    }

    .steps-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        .step-icon {
          width: 0.7rem;
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .step-text {
          font-size: 0.2rem;
          font-weight: 600;
          color: #4b2209;
        }
      }

      .step-arrow {
        flex: 0.5;
        display: flex;
        justify-content: center;

        img {
          width: 0.7rem;
          height: 0.16rem;
          margin-bottom: 0.4rem;
        }
      }
    }
  }
}

// result_sjh 进件成功样式
$primaryColor: #e71a0f;

.container {
  background: #f2f5fa;
  height: 100vh;
  overflow: auto;
  padding-bottom: 2rem;

  .top-con {
    padding: 0.44rem 0 1.36rem;
    background: linear-gradient(40deg, #ff5612, #fd7539);
    font-size: 0.24rem;
    font-family: 'PingFang SC', 'PingFang SC-Regular', sans-serif;
    font-weight: normal;
    color: #fff;
    text-align: center;

    &-tit {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 1.26rem;
        height: 1rem;
      }

      h4 {
        position: relative;
        top: 0.1rem;
        font-size: 0.36rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
      }
    }

    > h4 {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: normal;
      margin: 0.32rem 0 0.1rem;
    }

    > p {
      font-size: 0.2rem;
      font-family: 'PingFang SC', 'PingFang SC-Regular', sans-serif;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .mechanism-con {
    margin-top: -0.74rem;
    padding: 0 0.16rem;

    > .mechanism-info {
      margin-top: -0.1rem;
      padding: 0 0.24rem;

      .mechanism-info-div-success {
        margin-top: 10px;
        background: #ffffff;
        border-radius: 0.2rem;
        position: relative;
        padding: 1.14rem 0 0.2rem;
        text-align: center;

        .success-phone {
          width: 1.66rem;
          position: absolute;
          top: -0.83rem;
          left: calc(50% - 0.83rem);
        }

        .success-title {
          font-weight: 600;
          font-size: 0.36rem;
          color: #333333;
        }

        .success-tips {
          padding: 0 1.18rem;
          font-weight: 400;
          font-size: 0.22rem;
          color: #333333;
        }

        .success-info {
          margin-top: 0.28rem;
          border-top: 1px dotted #e6e5e5;
          padding: 0 0.32rem 0;

          .success-info-name {
            span {
              font-weight: 600;
              font-size: 0.28rem;
              color: #333333;
            }
          }

          .success-info-basic {
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 0.22rem;
            color: #333333;
            margin-bottom: 0.24rem;

            .success-info-basic-label {
              color: #9a9a9a;
            }
          }

          .success-tips {
            background: #fff4ef;
            border-radius: 0.12rem;
            color: #ff5d0e;
            padding: 0.12rem 0 0.12rem 0.2rem;
          }
        }
      }

      .mechanism-info-div {
        width: 100%;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.2rem;
        padding: 0.22rem 0.3rem 0.36rem;
        font-size: 0.22rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        color: #838f9f;

        .origan-desc {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Thin;
          font-weight: normal;
          color: #111c31;
          line-height: 0.34rem;
          margin-bottom: 0.4rem;
        }

        .origan-right {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #111c31;
        }
      }

      .pagecard {
        margin-top: 0.16rem;
        background: #ffffff;
        border-radius: 0.24rem;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        padding: 0.32rem;
        box-sizing: border-box;

        > h4 {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: normal;
          color: #333333;
          margin-bottom: 0.24rem;

          span {
            margin-left: 0.1rem;
            font-size: 0.24rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: normal;
            color: #666;
          }
        }

        &-process {
          background-color: #fff;
          border-radius: 0.3rem;
          margin-top: 0.3rem;

          .loan-process-li {
            > img {
              width: 0.64rem;
              height: 0.64rem;
              border-radius: 50%;
            }

            .icon-img {
              width: 0.22rem;
              height: 0.22rem;
              border-radius: 50%;
              margin-right: 0.06rem;
            }

            h6 {
              font-size: 0.24rem;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: normal;
              color: #333333;
              margin: 0.2rem 0 0.2rem;
            }

            span {
              color: #7d8090;
              font-size: 0.22rem;
            }

            span.default {
              color: #c2c3c4;
            }
          }

          .line {
            width: 0;

            > img {
              width: 0.6rem;
              height: 0.12rem;
              right: -0.3rem;
              top: -0.36rem;
            }
          }
        }
      }
    }
  }
}

.downloadBtnContainer {
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.34rem 0.54rem;
  background-color: #fff;
  box-shadow: 0 -0.2rem 0.1rem 0.06rem rgba(0, 0, 0, 0.03);
}

.download-app-btn {
  font-size: 0.32rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
  box-shadow: 0px 4px 10px 2px rgba(255, 136, 88, 0.28);
  border-radius: 0.54rem;
  margin: 0.2rem 0;

  .span {
    font-weight: bold;
  }
}
</style>
